"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolve = exports.getThemedChart = exports.getPalette = void 0;
var map_1 = __importDefault(require("lodash/map"));
var find_1 = __importDefault(require("lodash/find"));
var palettes_1 = __importDefault(require("../constants/palettes"));
var _digital_report_palette_scss_1 = __importDefault(require("./../styles/_digital-report-palette.scss"));
var _annual_report_palette_scss_1 = __importDefault(require("./../styles/_annual-report-palette.scss"));
var paletteSets = {
    digital: _digital_report_palette_scss_1.default,
    annual: _annual_report_palette_scss_1.default,
};
var getPalette = function (palette) {
    return (0, map_1.default)(paletteSets[palette], function (_, index) { return paletteSets[palette][index]; });
};
exports.getPalette = getPalette;
var getColorsWithLastDataEntryHighlighted = function (data, palette, defaultPalette, colorIndex) {
    if (!data) {
        return defaultPalette;
    }
    var highlightBarPalette = paletteSets[palette]["highlighted".concat(colorIndex)];
    return data.map(function (_, index) {
        return data.length === index + 1 ? highlightBarPalette : defaultPalette;
    });
};
var getThemedChart = function (item, index, type, palette, highlightLastDataEntry) {
    if (!(0, exports.getPalette)(palette)) {
        return item;
    }
    switch (item.type || type) {
        case 'doughnut':
            item.backgroundColor = (0, exports.getPalette)(palette);
            break;
        case 'line':
            var color = (0, exports.getPalette)(palette)[index];
            item.borderColor = color;
            item.pointBackgroundColor = color;
            item.pointHoverBackgroundColor = color;
            break;
        case 'bar':
        case 'horizontalBar':
            var barPalette = (0, exports.getPalette)(palette)[index];
            if (highlightLastDataEntry) {
                var colorsWithLastDataEntryHighlighted = getColorsWithLastDataEntryHighlighted(item.data, palette, barPalette, index);
                item.borderColor = barPalette;
                item.backgroundColor = colorsWithLastDataEntryHighlighted;
                item.borderWidth = 1;
            }
            else {
                item.borderColor = barPalette;
                item.backgroundColor = barPalette;
            }
            item.hoverBackgroundColor =
                paletteSets[palette]["hover".concat(index + 1)];
            break;
        default:
            item.backgroundColor = (0, exports.getPalette)(palette);
            break;
    }
    return item;
};
exports.getThemedChart = getThemedChart;
// The palette is resolved by <body class="js-report--{palette}">
var resolve = function () {
    return (0, find_1.default)(palettes_1.default, function (value) {
        return (document.getElementsByClassName("js-report--".concat(value)).length > 0);
    });
};
exports.resolve = resolve;
